/**
 * 规划第三阶段 P3-7（计划 P3-7 D-321）：规则面板及其裁定、开发明细表、设置中的规则数值以及规则拒绝的措辞。
 * 通过 intake-zh.ts 展开。
 */
export default {
  rules: {
    title: '规划规则',
    advisory: '仅供参考：结果用于协助评估。未通过或需要官员判断的规则，须在案件提交会议前作出裁定。',
    none: '此案件尚未评估规则。',
    run: '评估规则',
    rerun: '重新评估',
    requested: '规则已评估。',
    failed: '最近一次评估无法记录：{{reason}}',
    meta: '版本 {{revision}}，评估于 {{date}}',
    packVersion: '规则集来自规则包版本 {{version}}',
    valuesChanged: '市政局在此次评估后更改了规则数值。请重新评估以采用新数值。',
    older: '此次评估针对版本 {{revision}}；案件现为版本 {{current}}。',
    citation: '{{document}}，第 {{page}} 页',
    actualRequired: '{{actual}}（要求：{{required}}）',
    trigger: { staged: '图纸检查之后', on_demand: '按要求' },
    status: {
      pass: '符合规则',
      fail: '不符合规则',
      needs_officer: '需要官员判断',
      not_applicable: '不适用',
      not_configured: '市政局未设数值',
    },
    reasons: {
      slots_missing: '市政局尚未输入此规则所需的全部数值。',
      schedule_missing: '尚未申报开发明细表，或明细表中有一行未填写此规则所需的数量。',
      site_missing: '此版本在登记册中没有地块边界。',
      flag_missing: '此规则所需的案件事实尚未记录。',
      zero_base: '作为除数的基数为零。',
      lookup_missing: '市政局没有为所申报的开发类型设定数值。',
      lookup_ambiguous: '申报了多于一种开发类型；由官员决定适用哪个数值。',
      invalid_input: '此规则读取的数值不是数字。',
    },
    reportErrors: {
      register_rows_missing: '此版本没有登记行',
      superseded: '较新的版本已先行取代此版本',
      rules_not_configured: '尚未输入规则数值',
      other: '评估已中止',
    },
    determinations: {
      title: '裁定',
      open: '{{number}} 项待裁定',
      pending: '尚未裁定',
      recorded: '{{outcome}}，记录于 {{date}}',
      note: '备注：{{note}}',
      record: '记录',
      change: '更改',
    },
    determine: {
      title: '裁定：{{rule}}',
      intro: '记录您对此规则的裁定。结果仍仅供参考。',
      outcome: '结果',
      outcomeRequired: '请选择结果。',
      note: '备注',
      noteHint: '可选。官员和市政局各部门可见；申请人不可见。',
      replaces: '此裁定将取代 {{date}} 记录的裁定。',
      confirm: '记录',
      cancel: '取消',
      done: '裁定已记录。',
    },
    outcomes: { complies: '符合', acceptable: '可接受', objection: '反对' },
    schedule: {
      title: '开发明细表',
      intro: '申请人对开发项目的申报。规划规则会读取这些内容。',
      none: '尚未申报开发明细表。',
      type: '开发类型',
      edit: '编辑明细表',
      add: '添加一行',
      remove: '删除',
      removeLabel: '删除第 {{number}} 行',
      save: '保存明细表',
      cancel: '取消',
      saved: '明细表已保存。',
      typeRequired: '请为每一行选择开发类型。',
      notNumber: '请输入 0 或以上的数字。',
      notWhole: '请输入整数。',
      tooMany: '最多 {{max}} 行。',
      row: '第 {{number}} 行',
    },
    settings: {
      title: '规划规则',
      description: '规则包提供每个规则集的结构和引用。请输入贵市政局自己的数值；留空的规则集不予采用。',
      setsVersion: '规则集来自规则包版本 {{version}}',
      none: '规则包没有声明任何规则集。',
      adopted: '已采用',
      notAdopted: '未采用',
      citationNoPage: '{{document}}（页码待核对）',
      import: '导入数值（JSON）',
      export: '导出数值（JSON）',
      importFailed: '该文件不是规则数值导出文件。',
      imported: '数值已载入。请检查后保存。',
      importDropped: '未载入的值：{{count}} 个。此规则包版本未声明这些值，或值与其字段不符。',
      importVersion: '此文件导出自另一版本的规则集。保存前请检查各项值。',
      save: '保存规则数值',
      saving: '正在保存…',
      saved: '规则数值已保存。',
      blocked: '部分数值无法保存。请更正上方标出的项目。',
      digest: '数值摘要：{{digest}}',
      units: {
        m2: '平方米',
        percent: '百分比',
        count: '数量',
        ratio: '比率',
        per_hectare: '每公顷',
      },
      bands: { upTo: '最多至', open: '及以上', per: '每多少设一个', add: '添加分段', remove: '删除第 {{number}} 段' },
      table: { type: '开发类型', value: '数值' },
      references: {
        title: '开发类型及贵方参考',
        hint: '可选：贵市政局为每种类型设定的参考，例如指南章节。它与您的规则数值一同保存在此处并一同导出。',
        label: '{{type}} 的参考',
      },
      problems: {
        notNumber: '请输入 0 或以上的数字。',
        notPercent: '请输入 0 至 100 的比例。',
        bands: '分段须递增，每段比率须大于 0；只有最后一段可以没有上限。',
        table: '请输入 0 或以上的数字。',
        reference: '最多 120 个字符。',
        tooLarge: '最多 1,000,000,000。',
        tooManyBands: '最多 20 段。',
      },
    },
  },
  errors: {
    rules_not_configured: '此市政局尚未输入规则数值。管理员可在“设置 → 规划”中输入。',
    rule_report_not_found: '该规则评估不属于此案件。',
    rule_report_not_done: '该规则评估未完成。请重新加载页面后重试。',
    rule_report_superseded: '该规则评估已被较新的评估取代。请重新加载页面后重试。',
    rule_report_changed: '页面加载后该规则评估已更改。请重新加载页面后重试。',
    rule_not_determinable: '在此次评估中该规则无需裁定。',
  },
} as const
